import React from "react"
import styled from "styled-components"

const LegendWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`

const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const LegendGroup = () => {
  return (
    <LegendWrapper>
      <Legend>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
        >
          <circle cx="7.51172" cy="7" r="5" stroke="#4282EF" stroke-width="4" />
        </svg>
        정읍
      </Legend>
      <Legend>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
        >
          <circle cx="7.51172" cy="7" r="5" stroke="#AC8CFF" stroke-width="4" />
        </svg>
        대전
      </Legend>
      <Legend>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
        >
          <circle cx="7.51172" cy="7" r="5" stroke="#FAA93E" stroke-width="4" />
        </svg>
        보령
      </Legend>
      <Legend>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
        >
          <circle cx="7.51172" cy="7" r="5" stroke="#94D474" stroke-width="4" />
        </svg>
        여수
      </Legend>
    </LegendWrapper>
  )
}

export default LegendGroup
